import {Component, Input, OnInit} from '@angular/core';
import {DatePipe, NgIf} from "@angular/common";
import {ClarityModule, ClrDatagridSortOrder} from "@clr/angular";
import {RouterLink} from "@angular/router";
import {Orders } from "../../../../_shared/interfaces";
import {AlertService, IAlertType, ProjectsStoreService} from "../../../../_shared/services";

@Component({
  selector: 'app-used-in-orders',
  standalone: true,
  imports: [
    NgIf,
    ClarityModule,
    RouterLink,
    DatePipe
  ],
  templateUrl: './used-in-orders.component.html',
  styleUrl: './used-in-orders.component.sass'
})
export class UsedInOrdersComponent implements OnInit {
  orders: Orders[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;

  @Input() componentId: string = '';

  constructor(
    private prss: ProjectsStoreService,
    private alertDispatcher: AlertService
  ) { }

  ngOnInit() {
    this.loadList(this.componentId);
  }

  loadList(component: string) {
    this.prss.getUsedInOrders(component)
      .subscribe({
        next: data => {
          if (!data || !data.object || data.object.length === 0) {
            this.alertDispatcher.show({
              message: ' Keine Projekte gefunden! ',
              clrAlertType: IAlertType.WARNING
            }, 5000);
            this.loading = false;
            return;
          }
          this.orders = data.object;
        },
        complete: () => {
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          return
        }
      })
  }
}
